const NavButtons = ({ style }) => {
	return (
		<div className="nav-buttons" style={style}>
			<button className="nav-button">COMPARE</button>
			<button className="nav-button">LOCATIONS</button>
			<button className="nav-button">IMPRINT</button>
		</div>
	)
}

export default NavButtons
